import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import { UtilsService } from './services/utils.service';

@Injectable()

export class TokenInterceptor implements HttpInterceptor {
  constructor(private utils: UtilsService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log(req.url, req.body);
    if (req.body && (req.body.otp || req.body.OtpKey)) {
      const token = JSON.parse(this.utils.getToken());
      const userToken = (token && token.userToken) ? token.userToken : '';

      const modufuedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${userToken}`,
        }
      });
      return next.handle(modufuedReq);
    }
    return next.handle(req);
  }
}
